export class InvoiceRequest {
    poNumber?: number;
    poDateStartDate? :any;
    poDateEndDate? :any;
    shipmentDateStartDate?:any;
    shipmentDateEndDate?:any;
   isInvoiced?:string;
   unitId?:number;
   companyId?:number;
    /**
     * @paarm poNumber
     */
    constructor(poNumber?:number,poDateStartDate? :any, poDateEndDate? :any,shipmentDateStartDate?:any,shipmentDateEndDate?:any,
   isInvoiced?:string,unitId?:number,companyId?:number

    ){
        this.poNumber = poNumber;
        this.poDateStartDate= poDateStartDate;
        this.poDateEndDate= poDateEndDate;
        this.shipmentDateStartDate = shipmentDateStartDate;
        this.shipmentDateEndDate = shipmentDateEndDate;
        this.isInvoiced = isInvoiced;
        this.unitId = unitId;
        this.companyId = companyId;
        
    }
}


export class ShippedDateRequest {
    poNumber?: any;
    shipmentDateStartDate? :any;
    shipmentDateEndDate? :any;
    unitId?:number;
    companyId?: number;
    invoiceStartDate?: any;
    invoiceEndDate?: any;
   
    /**
     * @paarm poNumber
     */
    constructor(poNumber?:any,shipmentDateStartDate? :any, shipmentDateEndDate? :any,unitId?:number,companyId?: number, invoiceStartDate?: any,
        invoiceEndDate?: any){
        this.poNumber = poNumber;
        this.shipmentDateStartDate= shipmentDateStartDate;
        this.shipmentDateEndDate= shipmentDateEndDate;
        this.unitId = unitId;
        this.companyId = companyId;
        this.invoiceStartDate=invoiceStartDate;
        this.invoiceEndDate=invoiceEndDate
    }
}


export class ReportRequest {
  
    startDate? :any;
    endDate? :any
   unitId?:number
    /**
     * @paarm poNumber
     */
    constructor(startDate? :any, endDate? :any,unitId?:number){
       
        this.startDate= startDate;
        this.endDate= endDate;
        this.unitId=unitId
        
    }
}
